<ng-template
  let-extraClass="extraClass"
  #topNav>
  @if (!windowService?.isDesktopRes) {
    <tidy-top-nav
      [title]="'Automations'"
      [class]="extraClass"
      [canGoBack]="true"
      [customBack]="'more'" />
  }
</ng-template>

<ng-container *ngTemplateOutlet="topNav;context:{ extraClass: 'mobile' }" />

<ng-template #content>
  <tidy-wrapper [isPrimaryLayer]="true">

    @if (windowService?.isDesktopRes) {
      <tidy-desktop-header>
        <div class="wrappable-container">
          <tidy-text
            [title]="'Automations'" />
          @if (!showFilterChipsOnSecondRow) {
            <tidy-header-select
              [items]="workflowFiltersList"
              [form]="form.get('workflowFilter')"
                            (optionChange)="changeWorkflowFilter($event)"
              [icon]="'assets/svg/list.svg'" />
            <tidy-header-select
              [items]="propertyFiltersList"
              [form]="form.get('propertyFilter')"
                            (optionChange)="changePropertyFilter($event)"
              [icon]="'assets/svg/home.svg'" />
          }
          <tidy-small-button
            [text]="'Custom Workflow Runs'"
            [image]="'assets/img/settings-white.svg'"
            (buttonClick)="goToWorkflowHistory()" />
          <tidy-small-button
            [text]="'Add Workflow'"
            [image]="'assets/img/add-button-white.svg'"
            (buttonClick)="goToAddAutomationPage()" />
        </div>
        <div class="non-wrappable-right-aligned-container">
          @if (showLoadingSpinner) {
            <ion-spinner name="lines" class="header-loading-spinner" />
          }
        </div>
      </tidy-desktop-header>
      @if(showFilterChipsOnSecondRow && loaded) {
        <tidy-desktop-header>
          <div class="wrappable-container">
            <tidy-header-select
              [items]="workflowFiltersList"
              [form]="form.get('workflowFilter')"
                            (optionChange)="changeWorkflowFilter($event)"
              [icon]="'assets/svg/list.svg'" />
            <tidy-header-select
              [items]="propertyFiltersList"
              [form]="form.get('propertyFilter')"
                            (optionChange)="changePropertyFilter($event)"
              [icon]="'assets/svg/home.svg'" />
          </div>
        </tidy-desktop-header>
      }
    }

    <!-- Skeleton table while loading — rows float in with the entrance cascade;
         the real table below then replaces it in place, instantly (skipEntrance). -->
    @if (!loaded || !filterLoaded) {
      <tidy-table
        [skeletonLoading]="true"
        [columnslabels]="headers" />
    }

    @if (loaded && filterLoaded) {
      <tidy-table
        #tidyTable
        [dataSource]="currentRows"
        [displayedColumns]="headers"
        [columnslabels]="headers"
        [allRowIsClickable]="true"
        [showColumnLines]="false"
        (cellClick)="goToAutomation($event)"
        (pageChange)="pageChange($event)"
        [infiniteScroll]="true"
        [blockSorting]="true"
        [skipEntrance]="true"
        [didLoadAllRows]="didLoadAllRows" />
    }

      </tidy-wrapper>
    </ng-template>

    <app-scroll-wrapper [isfullWidthContent]="true" [templateContent]="content" />

